import React, { useEffect, useRef } from 'react';
import {
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';
import { Stack, Text } from '@/theme/components';
import { formatPhone, unformatPhone } from '@/utils/formatPhone';
import { StyledAddressStack, StyledInput } from './Components';
import { BubbleForm } from './types';
import { StyledInputLabel } from '../components';

export const FormStepTwo: React.FC<{
  register: UseFormRegister<BubbleForm>;
  setValue: UseFormSetValue<BubbleForm>;
  trigger: UseFormTrigger<BubbleForm>;
}> = ({ register, trigger, setValue }) => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    trigger(['first_name', 'last_name', 'phone']);
  }, [trigger]);

  useEffect(() => {
    if (titleRef.current) {
      setTimeout(
        () =>
          titleRef.current!.scrollIntoView({
            behavior: 'smooth',
          }),
        0
      );
    }
  }, [titleRef]);

  return (
    <>
      <Text variant="h2" ref={titleRef} mb={[1.25, 2]} mt={1}>
        Contact Information
      </Text>
      <Text variant="body1" mb={[2, 4]}>
        Get $5 when you request a customized homeowner insurance quote from
        Bubble*
      </Text>
      <Stack direction={['column', 'row']} columnGap={1.5} rowGap={2.5}>
        <StyledAddressStack direction="column" gap={1}>
          <StyledInputLabel htmlFor="first_name">First Name</StyledInputLabel>
          <StyledInput
            {...register('first_name', {
              required: true,
              onChange: () => trigger('first_name'),
            })}
            id="first_name"
            key="first_name"
            fullWidth
          />
        </StyledAddressStack>
        <StyledAddressStack direction="column" gap={1}>
          <StyledInputLabel htmlFor="last_name">Last Name</StyledInputLabel>
          <StyledInput
            {...register('last_name', {
              required: true,
              onChange: () => trigger('last_name'),
            })}
            id="last_name"
            key="last_name"
            fullWidth
          />
        </StyledAddressStack>
        <StyledAddressStack direction="column" gap={1}>
          <StyledInputLabel htmlFor="state">Phone</StyledInputLabel>
          <StyledInput
            {...register('phone', {
              required: true,
              onChange: (e) => {
                let phone = unformatPhone(e.target.value);
                if (phone[0] === '1') {
                  phone = phone.substring(0, 11);
                } else {
                  phone = phone.substring(0, 10);
                }

                setValue('phone', formatPhone(phone));
                trigger('phone');
              },
            })}
            id="phone"
            key="phone"
            type="tel"
            name="phone"
            placeholder="(___) ___-____"
            sx={{ fontSize: '1rem' }}
            fullWidth
          />
        </StyledAddressStack>
      </Stack>
    </>
  );
};
